import { inject, Injectable } from '@angular/core';
import { Observable, map, catchError, throwError } from 'rxjs';
import { NotifyService } from '@src/app/shared/services/notiflix/notify.service';
import { iApiResponse } from '@src/app/core/interfaces/iApiResponse';
import { AuthPermissionApi } from '../Apis/auth-permission.api';

@Injectable({
  providedIn: 'root'
})
export class GetPermissionsAction {

  private service = inject(AuthPermissionApi);
  private notifyService = inject(NotifyService);

  execute(): Observable<iApiResponse> {
    return this.service.getAll().pipe(
      map(response => response),
      catchError(err => {
      this.notifyService.error(err.error?.error?.message ?? err.message)
        return throwError(() => err);
      }),
    );
  }
}
